import {
  ChipList,
  InputToggle,
  SearchDropdown,
  TextBox,
} from "../inputs";
import InputGroup from "../inputs/components/inputGroup";
import evaluateCondition from "../../util/operations";

function FieldRenderer({
  field,
  form,
  parentKey,
  readOnly,
  viewModeCondition = false,
  company_modules = []
}) {
  const disableWhen = () => {
    // If a condition for field `disableWhen` is available
    if (field.disableWhen) {
      return evaluateCondition({ ...form.values, _external: { module: company_modules } }, field.disableWhen, {
        debug_mode: true,
      }).data;
    }
    return false;
  };
  const hideInView = () => {
        // If a condition for field `hideInView` is available
    if (field.hideInView) {
      return evaluateCondition({ ...form.values, _external: { module: company_modules } }, field.hideInView, {
        debug_mode: true,
      })?.data;
    }
    return false;
  };

  const _viewModeCondition =
    viewModeCondition ||
    (field.hideInView && hideInView());

  switch (field.type) {
    case "group":
      return (
        <div
          id={field.label.toLowerCase().replace(" ", "")}
          className={`${
            _viewModeCondition ? (!readOnly ? "" : "hidden") : ""
          } container mx-auto mt-4`}
        >
          <div className="flex items-center">
            <div className="w-1/14 border-b border-gray-400"></div>
            <div className="mr-4 text-md text-gray-700">{field.label}</div>
            <div className="flex-grow border-b border-gray-400"></div>
          </div>
          <div className="grid mt-4 mb-4 grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-3">
            {field.fields?.map((childField, index) => (
              <FieldRenderer
                key={index}
                field={childField}
                form={form}
                parentKey={field.key}
                viewModeCondition={_viewModeCondition}
                readOnly={readOnly}
                company_modules={company_modules}
              />
            ))}
          </div>
        </div>
      );
    case "toggle":
      return (
        <InputToggle
          formik={form}
          readOnly={readOnly}
          className={`${
            _viewModeCondition ? (!readOnly ? "" : "hidden") : ""
          } ${field.className}`}
          label={field.label}
          name={parentKey ? `${parentKey}.${field.key}` : field.key}
          disabled={disableWhen({ ...form.values })}
          required={field.required}
        />
      );
    case "chip-list":
      return (
        <ChipList
          {...field}
          formik={form}
          readOnly={readOnly}
          className={`${
            _viewModeCondition ? (!readOnly ? "" : "hidden") : ""
          } ${field.className}`}
          label={field.label}
          name={parentKey ? `${parentKey}.${field.key}` : field.key}
          required={field.required}
          disabled={disableWhen({ ...form.values })}
        />
      );
    case "dropdown":
      return (
        <SearchDropdown
          formik={form}
          readOnly={readOnly}
          name={parentKey ? `${parentKey}.${field.key}` : field.key}
          label={field.label}
          className={`${
            _viewModeCondition ? (!readOnly ? "" : "hidden") : ""
          } ${field.className}`}
          placeholder={field.placeholder}
          options={field.options}
          optionId={field.optionid}
          optionName={field.optionName}
          showNull={!!field.showNull}
          nullLabel={field.nullLabel}
          disabled={disableWhen({ ...form.values })}
          required={field.required}
        />
      );
    case "inputGroup":
      return (
        <InputGroup
          {...field}
          formik={form}
          readOnly={readOnly}
          name={parentKey ? `${parentKey}.${field.key}` : field.key}
          label={field.label}
          className={`${_viewModeCondition ? (!readOnly ? "" : "hidden") : ""
            } ${field.className}`}
          placeholder={field.placeholder}
          disabled={disableWhen({ ...form.values })}
          required={field.required}
          fields={field.fields}
        />
      );
    default:
      return (
        <TextBox
          attributes={field.attributes}
          formik={form}
          readOnly={readOnly}
          name={parentKey ? `${parentKey}.${field.key}` : field.key}
          label={field.label}
          className={`${
            _viewModeCondition ? (!readOnly ? "" : "hidden") : ""
          } ${field.className}`}
          type={field.type}
          placeholder={field.placeholder}
          disabled={disableWhen({ ...form.values })}
        />
      );
  }
}

export default FieldRenderer;
